// Lib 
import React from 'react';
import { createBrowserHistory } from "history";
import { Provider, shallowEqual, useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Router } from 'react-router-dom';

// Components
import { TokenManager } from "./features/Security/TokenManager"

// Styles
import { MainAppContainer } from './AppStyles';

// Fns
import store from './store/store';
import { AuthContext, AuthProvider } from 'features/Security/AuthContext';
import Loader from 'components/Loader';
import { RootState } from 'store/types';
import { postLoginApi, setIsLoggedIn, postUserDataApi } from 'features/Security/state/actions';
import { serviceLoading } from 'common/loaderReducer';
import { POST_LOGIN_API_REQUEST } from 'features/Security/state/actionTypes';
import Home from 'features/Home';

//types
import { SessionUser } from 'features/Security/state/types';


import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

declare let pendo: any;

const history = createBrowserHistory();

function App() {

    return (
        <Provider store={store}>
            <Router history={history}>
                <GateKeeper />
            </Router>
        </Provider>
    )
}

function GateKeeper() {
    const [lastUserData, setLastUserData] = React.useState<SessionUser | undefined>(undefined);
    const [cmsUser, setCMSUser] = React.useState<string | undefined>(undefined);
    const tokenManager = TokenManager.getInstance()
    const dispatch = useDispatch();
    const {
        isLoggedIn,
        accessToken,
        security,
        blurAPP,
        userData,
        selectedDealerId,
        isLoading
        
    } = useSelector((rootState: RootState) => {
        return {
            isLoggedIn: rootState.security.isLoggedIn,
            accessToken: rootState.security.accessToken,
            security:rootState.security,
            blurAPP:rootState.security.blurAPP,
            userData: rootState.security.user,
            selectedDealerId: rootState.dealers.dealer.selectedDealer?.id,
            isLoading: serviceLoading(rootState, [POST_LOGIN_API_REQUEST])
        }
    }, shallowEqual)

    
    React.useEffect(() => {
        
        if (userData) {
            if(userDataChanged())
            {
                setLastUserData(userData);
            }            
            //for Pendo insight
            pendo.initialize({
                visitor: {
                    id: userData.userId,
                    email: userData.email,
                    role: userData.role
                },
                account: {
                    id: selectedDealerId
                }
             });
             //end for Pendo insight
        }        
    }, [userData])

    React.useEffect(() => {       
        if (lastUserData && userData && selectedDealerId) {
            //for Pendo insight            
            pendo.updateOptions({
                visitor: {
                    id: userData.userId,
                    email: userData.email,
                    role: userData.role
                },
                account: {
                    id: selectedDealerId
                }
             });
             //end for Pendo insight
        }        
    }, [selectedDealerId])

    React.useEffect(() => {
        const savedAccessToken = tokenManager.getToken();
        if (cmsUser) {
            tokenManager.storeCMSUser(JSON.stringify(cmsUser))            
            if (savedAccessToken) {
                let userdata = tokenManager.getCSMUserData();
                let sessionuser;
                if (userdata!=null)
                    sessionuser = JSON.parse(userdata);
                dispatch(setIsLoggedIn(true,sessionuser))
            } else {
                if (!accessToken) {
                    if (!isLoading) {
                        dispatch(postLoginApi(cmsUser));
                    }

                } else {
                    tokenManager.storeToken(accessToken);     
                    tokenManager.storeCMSUserData(JSON.stringify(security.user))               
                    dispatch(setIsLoggedIn(true,security.user))
                }
            }
            

            
        }        
    }, [cmsUser, accessToken])

    return (
        <AuthProvider onLoggedIn={onLoggedIn}>
            {
                isLoggedIn ?
                    <AuthApp blurBackgroud={blurAPP} />
                    :
                    <Loader />
            }
     
        </AuthProvider >
    )


    function onLoggedIn(user) {
        setCMSUser(user)
    }

    function userDataChanged()
    {
        if(!lastUserData && userData)
        {
            return true;
        }
        if(!lastUserData && !userData)
        {
            return false;
        }
        if(lastUserData && !userData)
        {
            return true;
        }
        if(lastUserData && userData)
        {
            if(lastUserData.userId == lastUserData.userId)
            {
                return false;
            }
            else
            {
                return true;
            }
        }
    }
}

export interface MainAppContainerProps {
    blurBackgroud?: boolean
}
    function AuthApp(props: MainAppContainerProps) {
        const authContext = React.useContext(AuthContext);
        const tokenManager = TokenManager.getInstance()
        return (
            <MainAppContainer blurBackgroud={props.blurBackgroud}>
                <BrowserRouter>
                    <Home />
                </BrowserRouter>
            </MainAppContainer>
        );
    }

export default App;
